import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import config from 'Config';
import session from 'Src/session';
import Contact from 'Src/shared/contact';
const { Panel } = Contact;

class Complete extends Component {
  constructor (props) {
    super(props);
    self.state = {
      page: self.page
    };
  }
  state = {};
  componentDidMount () {
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    const self = this;
    // 個人情報取得に関する同意がされていない場合はトップへ戻る
    if (!session.isAgreed()) {
      window.location.href = config.path.root;
      return;
    }
    const savedReservationCode = session.getReservationCode();
    if (savedReservationCode) {
      self.setState({ savedReservationCode });
    }
    // ここで個人情報取得に関する同意を削除
    //   リロードをした場合はトップへ戻るようになる
    //   ブラウザの戻る等をして入力・入力確認に戻った場合もトップへ強制的に戻る
    // 照会・変更の場合の認証情報を削除
    session.removeAll();
  }
  render () {
    const self = this;
    const reservationCode = self.state.savedReservationCode;
    return (
      <Contact theme="positive">
        <div className="mb-3">
          <picture>
            <source srcSet={`${self.titleImgSpUrl} 1x, ${self.titleImgSp2xUrl} 2x`} media="(max-width: 575px)" />
            <img
              src={self.titleImgUrl}
              srcSet={`${self.titleImgUrl} 1x, ${self.titleImg2xUrl} 2x`}
              alt={self.titleImgAlt}
              className="img-fluid w-100"
            />
          </picture>
        </div>
        <Panel title={self.title}>
          <div className="container-fluid py-2">
            <div className="d-flex flex-column flex-sm-row">
              <div className="flex-fill">
                <p>{self.text}</p>
                {reservationCode && (
                  <div>
                    <p className="h6">
                      予約番号は<span className="text-danger h3 font-weight-bold mx-1">{reservationCode}</span>です。
                    </p>
                    <p className="text-danger">予約番号は照会・変更時に必要となりますので、保存しておいてください。</p>
                  </div>
                )}
                <p>
                  「終了」をクリックすると「お客様からの水道使用　開始・中止　などのお申込み」画面に戻ります。
                  <br />
                  {self.text2}
                </p>
              </div>
              <div>
                <img
                  src={self.tapkunImgUrl}
                  srcSet={`${self.tapkunImgUrl} 1x, ${self.tapkun2xImgUrl} 2x`}
                  className="mx-auto d-block"
                />
              </div>
            </div>
          </div>
        </Panel>
        <div className="container-fluid btn-toolbar justify-content-end p-2">
          <a href={config.path.root} className="btn btn-primary px-5">
            終了
          </a>
        </div>
      </Contact>
    );
  }
}

export class OpenComplete extends Complete {
  page = config.path.open_complete;
  title = '開始予約申込受付完了';
  text = '「開始予約の申込」を受付けました。';
  text2 = 'なお、「開始予約完了のお知らせ」をご登録いただいたメールアドレスにお送りしました。';
  titleImgAlt = '水道使用 開始予約 インターネット受付';
  titleImgUrl = require('Public/img/reservation-title-open.png');
  titleImg2xUrl = require('Public/img/reservation-title-open@2x.png');
  titleImgSpUrl = require('Public/img/sp-reservation-title-open.png');
  titleImgSp2xUrl = require('Public/img/sp-reservation-title-open@2x.png');
  tapkunImgUrl = require('Public/img/tap-01.png');
  tapkun2xImgUrl = require('Public/img/tap-01@2x.png');
}

export class CloseComplete extends Complete {
  page = config.path.close_complete;
  title = '中止予約申込受付完了';
  text = '「中止予約の申込」を受付けました。';
  text2 = 'なお、「中止予約完了のお知らせ」をご登録いただいたメールアドレスにお送りしました。';
  titleImgAlt = '水道使用 中止予約 インターネット受付';
  titleImgUrl = require('Public/img/reservation-title-close.png');
  titleImg2xUrl = require('Public/img/reservation-title-close@2x.png');
  titleImgSpUrl = require('Public/img/sp-reservation-title-close.png');
  titleImgSp2xUrl = require('Public/img/sp-reservation-title-close@2x.png');
  tapkunImgUrl = require('Public/img/tap-02.png');
  tapkun2xImgUrl = require('Public/img/tap-02@2x.png');
}

export class ChangeComplete extends Complete {
  page = config.path.change_complete;
  title = '予約変更受付完了';
  text = '「予約変更」を受付けました。';
  text2 = 'なお、「予約変更のお知らせ」をご登録いただいたメールアドレスにお送りしました。';
  titleImgAlt = '開始・中止の予約照会・変更・取消';
  titleImgUrl = require('Public/img/reservation-title-inquiry.png');
  titleImg2xUrl = require('Public/img/reservation-title-inquiry@2x.png');
  titleImgSpUrl = require('Public/img/sp-reservation-title-inquiry.png');
  titleImgSp2xUrl = require('Public/img/sp-reservation-title-inquiry@2x.png');
  tapkunImgUrl = require('Public/img/tap-03.png');
  tapkun2xImgUrl = require('Public/img/tap-03@2x.png');
}

export class CancelComplete extends Complete {
  page = config.path.cancel_complete;
  title = '予約取消受付完了';
  text = '「予約取消」を受付けました。';
  text2 = 'なお、「予約取消のお知らせ」をご登録いただいたメールアドレスにお送りしました。';
  titleImgAlt = '開始・中止の予約照会・変更・取消';
  titleImgUrl = require('Public/img/reservation-title-inquiry.png');
  titleImg2xUrl = require('Public/img/reservation-title-inquiry@2x.png');
  titleImgSpUrl = require('Public/img/sp-reservation-title-inquiry.png');
  titleImgSp2xUrl = require('Public/img/sp-reservation-title-inquiry@2x.png');
  tapkunImgUrl = require('Public/img/tap-04.png');
  tapkun2xImgUrl = require('Public/img/tap-04@2x.png');
}

export default Complete;
